import http from "@/http";
import {endLoadTable, Forbidden, notifySuccess} from "@/components/composables/functions";

export const state = {
    listAll: {},
    listCards: {}
}

export const mutations = {
    getList(state, newValue) {
        const page = newValue.page || 0;
        const limit = document.getElementById('limitFilter') ? document.getElementById('limitFilter').value : 0;
        const count = newValue.count || 0;
        newValue.start = count > 0 ? page * limit + 1 : 0;
        newValue.partial = count <= (page + 1) * limit ? count : (page + 1) * limit;

        state.listAll = newValue

        let after = state.listCards.data || {};
        after = Object.values(after);
        let arr = [];

        for (let i = 0; i < Object.keys(after).length; i++) {
            arr.push(after[i]);
        }

        const newArr =  newValue.data || [];

        for (let i = 0; i < newArr.length; i++) {
            arr.push(newArr[i]);
        }

        state.listCards = {
            page,
            limit,
            count,
            partial: count <= (page + 1) * limit ? count : (page + 1) * limit,
            data: arr
        };
    },

    getValues(state, newValue) {
        state.listAll = newValue
        state.listCards = newValue
    }
}

export const actions = {
    // eslint-disable-next-line no-unused-vars
    init({state, dispatch}) {
        dispatch('validate')
    },

    getApi({commit}, url) {
        http.get(url, {
            headers: {'Authorization': ` Bearer ${localStorage.getItem('token')} `}
        })
            .then(response => {
                commit('getList', response.data);
                endLoadTable();
                if (document.getElementById('spinnerTable')) document.getElementById('spinnerTable').style.display = 'none';
                if (document.getElementById('spinnerCard')) document.getElementById('spinnerCard').style.display = 'none';
            })
            .catch(error => {
                endLoadTable();
                console.error(error);
                Forbidden(error);
            })
    },

    async insert({dispatch}, data) {
        let url = data.url;
        let formData = data.formData;
        if (formData.id > 0) {
            url += `/${formData.id}`;
            formData._method = 'PUT';
            delete formData.password;
        }
        return await http.post(url, formData, {
            headers: {'Authorization': ` Bearer ${localStorage.getItem('token')} `}
        })
            .then((response) => {
                dispatch('getApi', data.url);
                if (document.getElementById('spinnerCard')) document.getElementById('spinnerCard').style.display = 'none';
                notifySuccess(response.data.message);
                return true;
            })
            .catch(error => {
                console.error(error);
                Forbidden(error);
                return false;
            })
    },

    async delete({commit, dispatch}, data) {
        const session = JSON.parse(localStorage.getItem(data.session));
        const id = data.id;
        const url = `${session.url}/${id}`;
        return await http.delete(url, {
            headers: {'Authorization': ` Bearer ${localStorage.getItem('token')} `}
        })
            .then(() => {
                // pegando os valores com js
                let start = document.getElementById('start').innerText;
                let partial = document.getElementById('partial').innerText;
                let count = document.getElementById('count').innerText;

                --partial;
                --count;

                // pegando os valores da store
                let newValues = state.listAll;

                // Se tive o valor total for menor que o inicio da lista,
                // diminuir o page e fazer nova busca
                if (partial === count && start > count) {
                    const newSession = session.params.page = newValues.page;
                    localStorage.setItem(session, newSession);
                    dispatch('getApi', session.url);
                    // se acabarem os itens desta página mas existirem mais páginas a frente,
                    //     fazer nova busca na mesma page
                } else if (partial < start && start < count) {
                    dispatch('getApi', session.url);
                    // se o total for 0, esvazia o objeto data para aparecer mensagem na tabela
                } else if (count === 0) {
                    newValues.data = {};
                    commit('getValues', newValues);
                    --start;
                    document.getElementById('start').innerText = start;
                }

                document.getElementById('partial').innerText = partial;
                document.getElementById('count').innerText = count;
                document.getElementById('line' + id).style.display = 'none';
            })
            .catch(error => {
                console.error(error);
                Forbidden(error);
            })
    }
}
